import React, { useCallback, useEffect, useState } from "react";
import Socket from "socket";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants
} from "shared/components/animations";
import profile from "assets/images/och/userr.jpeg";
import dummyuser from "assets/images/och/dummyuser.png";
import roundBtn from "assets/images/och/next-round.png";
import JokeCard from "../components/JokeCard";

const OCHRoundOver = ({
  amIWinner,
  PlayersRankInfo,
  roomId,
  users,
  currentPlayerScoreInfo,
  currentPlayer,
  joke
}) => {
  const Looserplayerrank = PlayersRankInfo?.find(
    (user) => user?.player_id === currentPlayer?.player_id
  );
  const otherPlayerInfo = PlayersRankInfo?.filter(
    (user) => user?.player_id != currentPlayer?.player_id
  );

  const [counter, setCounter] = useState(20);

  useEffect(() => {
    let timer;
    timer =
      counter > 0 && setInterval(() => setCounter((prev) => prev - 1), 1000);
    counter === 0 && onUpdateStatus("update");
    return () => clearInterval(timer);
  }, [counter]);

  const buttonPressAction = () => {
    const data = {
      action: "update-status",
      roomId
    };
Socket.sendMessage(data);
  };

  const onUpdateStatus = useCallback(
    _.debounce((type) => buttonPressAction(type), 1000, {
      leading: true,
      trailing: false
    }),
    [roomId]
  );
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      {amIWinner ? (
        <div className="round-over">
          <motion.h2   variants={fadeVariants} className="title">Round Over!</motion.h2>
          <motion.div variants={staticBounceVariants}  className="score-box">
            <h3 className="sub-heading">You’re the WINNER!</h3>
            <div className="scores">
              <div>
                <h4>Round Score</h4>
                <p className="score">
                  {currentPlayerScoreInfo[0]?.score || "0"}
                </p>
              </div>
              <div>
                <h4>Total Score</h4>
                <p className="score">
                  {currentPlayerScoreInfo[0]?.total_score || "0"}
                </p>
              </div>
            </div>
          </motion.div>
          <div className="top-players">
            {PlayersRankInfo?.map(
              (item) =>
                item?.rank_tag !== "WINNER" && (
                  <motion.div variants={staticBounceVariants}  className="player-box">
                    <div className="position-box">
                      <p className="name">{item?.rank_tag}</p>
                    </div>
                    {item?.profile_image ==="profileImage"?<img
                    src={dummyuser}
                    className="img-fluid profile"
                    alt=""
                  /> : <img
                    src={item?.profile_image}
                    className="img-fluid profile"
                    alt=""
                  />}
                    <div className="name-box">
                      <p className="name">{item?.display_name}</p>
                    </div>
                  </motion.div>
                )
            )}
          </div>
          <JokeCard joke={joke} />
          <motion.div variants={staticBounceVariants} className="next-round">
            <div className="round">
              <div className="next-button">
                <img
                  src={roundBtn}
                  onClick={() => onUpdateStatus()}
                  className="img-fluid profile"
                  alt=""
                />
                <p className="timer">{`(Auto-starts in ${counter} secs)`}</p>
              </div>
            </div>
          </motion.div>
        </div>
      ) : (
        <div className="round-over">
          <motion.h2  variants={fadeVariants} className="title">Round Over!</motion.h2>

          <div className="top-players">
            {otherPlayerInfo?.map((item) => (
              <motion.div variants={staticBounceVariants}  className="player-box" >
                <div className="position-box">
                  <p className={`name ${item?.rank_tag==="WINNER"?"winners":""}`}>{item?.rank_tag}</p>
                </div>
                <img
                  src={item?.profile_image}
                  className="img-fluid profile"
                  alt=""
                />
                <div className="name-box">
                  <p className="name">{item?.display_name}</p>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div variants={staticBounceVariants} className="score-box">
            <h3 className="sub-heading">{`You’re ${Looserplayerrank?.rank_tag} `}</h3>
            <div className="scores">
              <div>
                <h4>Round Score</h4>
                <p className="score">
                  {currentPlayerScoreInfo[0]?.score || "0"}
                </p>
              </div>
              <div>
                <h4>Total Score</h4>
                <p className="score">
                  {currentPlayerScoreInfo[0]?.total_score || "0"}
                </p>
              </div>
            </div>
          </motion.div>
          <JokeCard joke={joke} />
        </div>
      )}
    </motion.div>
  );
};

export default OCHRoundOver;
